import { useState, useEffect } from 'react';
import { GoogleMap, useJsApiLoader, MarkerF, DirectionsRenderer } from '@react-google-maps/api';
import { ICONS } from 'src/assets/library';
import { processArray } from 'src/helper';
import DynamicGoogleAutocompleteFields from './locationField';
import { GET_COORDINATES } from 'src/apiService/apiDeclaration';

const disableOptions = {
  fullscreenControl: false,
  streetViewControl: false,
  mapTypeControl: false,
  mapTypeControlOptions: {
    mapTypeIds: ['roadmap'],
  },
};
const MapRender = ({ coordinates, setCoordinates, setDistance, disabled }) => {
  const [map, setMap] = useState(null);
  const [center, setCenter] = useState({
    lat: 53.8008,
    lng: -1.5491,
  });
  const [loading, setLoading] = useState(false);
  const [directions, setDirections] = useState();
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyADhEQBb77x8axWW6tdxy-9tKQ2z5ZXgm0',
  });

  const computeTotalDistance = (result) => {
    var totalDist = 0;
    result.routes[0].legs.forEach((item) => {
      totalDist += item.distance.value;
    });
    const totalDistance = (totalDist / 1000 / 1.6093).toFixed(1);
    setDistance(totalDistance);
  };

  const calculateDirections = () => {
    try {
      const { origin, destination, inBetweenArray } = processArray(coordinates);
      if (origin && destination && inBetweenArray) {
        const directionsService = new window.google.maps.DirectionsService();
        directionsService.route(
          {
            origin,
            destination,
            waypoints: inBetweenArray.map(({ lat, lng }) => ({
              location: new window.google.maps.LatLng(lat, lng),
              stopover: true,
            })),
            travelMode: window.google.maps.TravelMode.DRIVING,
          },
          (result, status) => {
            if (status === window.google.maps.DirectionsStatus.OK) {
              computeTotalDistance(result);
              setDirections(result);
              const bounds = new window.google.maps.LatLngBounds();
              coordinates.forEach((coord) => {
                bounds.extend(new window.google.maps.LatLng(coord.lat, coord.lng));
              });
              bounds.extend(new window.google.maps.LatLng(origin.lat, origin.lng));
              map.fitBounds(bounds);
            } else {
              console.error('Error fetching directions:', result);
            }
          }
        );
      }
    } catch (err) {
      console.log(err);
    }
  };

  const removeCoordinate = (index) => {
    const updatedCoordinates = [...coordinates];
    updatedCoordinates.splice(index, 1);
    setCoordinates(updatedCoordinates);
  };

  const addCoordinate = () => {
    const updatedCoordinates = [
      ...coordinates,
      {
        lat: null,
        lng: null,
        address: null,
      },
    ];
    setCoordinates(updatedCoordinates);
  };

  const handlePlaceSelect = async (index, selectedPlace) => {
    if (loading) return;
    setLoading(true);
    try {
      const {
        data: { latitude, longitude },
      } = await GET_COORDINATES({ point: 'break', placeId: selectedPlace.value.place_id });
      const updatedCoordinates = [...coordinates];
      updatedCoordinates[index] = {
        lat: latitude,
        lng: longitude,
        address: selectedPlace.label,
      };
      setCoordinates(updatedCoordinates);
      setCenter({ lat: latitude, lng: longitude });
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  useEffect(() => {
    if (!map) return;
    if (coordinates.length < 0) return;
    calculateDirections();
    // eslint-disable-next-line
  }, [coordinates, map]);
  return (
    <>
      {isLoaded ? (
        <GoogleMap
          options={disableOptions}
          mapContainerStyle={{ width: '100%', height: '350px' }}
          zoom={13}
          center={center}
          onLoad={(map) => setMap(map)}
        >
          {directions && (
            <DirectionsRenderer
              suppressMarkers={true}
              options={{
                directions: directions,
                preserveViewport: true,
                suppressMarkers: true,
              }}
            />
          )}
          {coordinates?.map(
            ({ lat, lng }, index) =>
              lat !== null &&
              lng !== null && (
                <MarkerF
                  key={index}
                  position={{ lat, lng }}
                  icon={{
                    url: ICONS.pin,
                  }}
                />
              )
          )}
        </GoogleMap>
      ) : null}

      <DynamicGoogleAutocompleteFields
        disabled={disabled}
        loading={loading}
        removeCoordinate={removeCoordinate}
        addCoordinate={addCoordinate}
        coordinates={coordinates}
        handlePlaceSelect={handlePlaceSelect}
      />
    </>
  );
};

export default MapRender;
